/*
  Pre-selects the café closest to the customer in the catering "Pickup location"
  dropdown, using the browser's location permission. Customers can still choose
  any other café.

  - Only runs where the catering pickup dropdown exists (catering product pages
    and the catering popup, which is added to the page later).
  - A café the customer picks themselves is never overwritten, and is used on
    their later catering items instead of the closest one.
  - Only cafés that are options in the dropdown are considered.
  - Location blocked or unavailable: nothing is pre-selected and the customer
    chooses. Add to cart is held until a café is chosen, because the theme only
    shows a message and would otherwise add the item without one.

  Keys must match the option values in snippets/catering-pickup-location.liquid.
*/
(function () {
  var CAFES = {
    'Gardena':                  { lat: 33.916507, lng: -118.307007 },
    'Long Beach':               { lat: 33.789908, lng: -118.178434 },
    'Lawndale':                 { lat: 33.894108, lng: -118.351524 },
    'Bellflower':               { lat: 33.891040, lng: -118.125179 },
    'Santa Ana (McFadden Ave)': { lat: 33.738233, lng: -117.919241 },
    'Santa Ana (First Street)': { lat: 33.745609, lng: -117.863101 },
    'Orange - N Tustin St':     { lat: 33.818419, lng: -117.836014 },
    'Placentia':                { lat: 33.871599, lng: -117.862802 },
    'Bell':                     { lat: 33.978090, lng: -118.187076 }
  };

  window.lcCateringCafes = CAFES;

  var SELECT = '.m-catering-location-select';
  var POSITION_KEY = 'lc-catering-position';
  var CHOICE_KEY = 'lc-catering-choice';

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; }
  }

  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function milesBetween(lat1, lng1, lat2, lng2) {
    var rad = Math.PI / 180;
    var dLat = (lat2 - lat1) * rad;
    var dLng = (lng2 - lng1) * rad;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * rad) * Math.cos(lat2 * rad) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 3958.8 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  // Closest café among the options this particular dropdown offers.
  function nearestOption(select, pos) {
    var best = null;
    Array.prototype.forEach.call(select.options, function (opt) {
      var cafe = CAFES[opt.value];
      if (!cafe) return;
      var miles = milesBetween(pos.lat, pos.lng, cafe.lat, cafe.lng);
      if (!best || miles < best.miles) best = { value: opt.value, miles: miles };
    });
    return best;
  }

  function hasOption(select, value) {
    return Array.prototype.some.call(select.options, function (opt) { return opt.value === value; });
  }

  function allSelects() {
    return document.querySelectorAll(SELECT);
  }

  function statusRow(select) {
    var row = select.parentNode.querySelector('.lc-catering-locate');
    if (!row) {
      row = document.createElement('div');
      row.className = 'lc-catering-locate';
      row.setAttribute('aria-live', 'polite');
      select.insertAdjacentElement('afterend', row);
    }
    return row;
  }

  function showStatus(select, text, isError) {
    var row = statusRow(select);
    row.textContent = text;
    row.classList.toggle('is-error', !!isError);
  }

  var applying = false;
  function apply(select, value) {
    if (select.value === value) return;
    applying = true;
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    applying = false;
  }

  // Only fills a dropdown the customer hasn't set, or one this script filled.
  function fill(select, pos) {
    if (select.value && select.dataset.lcAutoFilled !== 'true') return;
    var best = nearestOption(select, pos);
    if (!best) return;
    apply(select, best.value);
    select.dataset.lcAutoFilled = 'true';
    showStatus(select, 'Closest café to you (' + best.miles.toFixed(1) + ' mi). You can choose another.');
  }

  var locating = false;
  function locate() {
    if (locating || !('geolocation' in navigator)) return;
    locating = true;
    navigator.geolocation.getCurrentPosition(function (p) {
      locating = false;
      var pos = { lat: p.coords.latitude, lng: p.coords.longitude };
      write(POSITION_KEY, pos);
      allSelects().forEach(function (s) {
        if (!usesChoice(s)) fill(s, pos);
      });
    }, function () {
      locating = false;
      try { localStorage.removeItem(POSITION_KEY); } catch (e) {}
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 10 * 60 * 1000 });
  }

  function usesChoice(select) {
    var choice = read(CHOICE_KEY);
    return !!choice && hasOption(select, choice);
  }

  function setUp(select) {
    if (select.dataset.lcLocator) return;
    select.dataset.lcLocator = 'true';

    if (usesChoice(select)) {
      if (!select.value) apply(select, read(CHOICE_KEY));
      return;
    }
    var pos = read(POSITION_KEY);
    if (pos) fill(select, pos);
    // Refresh so the pre-selected café follows the customer if they have moved.
    locate();
  }

  function init() {
    allSelects().forEach(setUp);

    // A café the customer picks is theirs: remember it and stop auto-filling.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (applying || !t.matches || !t.matches(SELECT)) return;
      delete t.dataset.lcAutoFilled;
      statusRow(t).textContent = '';
      statusRow(t).classList.remove('is-error');
      if (t.value) write(CHOICE_KEY, t.value);
    });

    function guard(e) {
      var form = e.type === 'submit' ? e.target : (e.target.closest && e.target.closest('button[type="submit"], [name="add"], [data-catering-atc]') || {}).form;
      if (!form || !form.querySelector) return;
      var select = form.querySelector(SELECT);
      if (!select || select.disabled || select.value) return;
      var pane = select.closest('[data-catering-mode-only]');
      if (pane && pane.hidden) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      showStatus(select, 'Please choose a pickup location.', true);
      select.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', guard, true);

    // The catering popup injects its form after the page loads.
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches(SELECT)) setUp(node);
          else node.querySelectorAll(SELECT).forEach(setUp);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
